import type { ReactElement } from 'react';
import React from 'react';
import { Input } from 'reactstrap';

// Define a default UI for filtering
export default function DefaultColumnFilter({
  column: {
    filterValue,
    preFilteredRows,
    setFilter,
    filterPlaceHolder = `Search ${preFilteredRows.length} records...`
  }
}): ReactElement {
  return (
    <Input
      value={filterValue || ''}
      onChange={(e): void => setFilter(e.target.value || undefined)}
      placeholder={filterPlaceHolder}
    />
  );
}
